import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelperService } from '../../services/helper/helper.service';

@Component({
  selector: 'app-datetimepicker',
  template: `
    <input
      [min]="min"
      [owlDateTimeTrigger]="dt8"
      [owlDateTime]="dt8"
      (dateTimeChange)="onDateSelect($event)"
      class="an-form-control"
      [(ngModel)]="date"
      readonly
    />
    <owl-date-time
      [disabled]="disabled"
      [pickerType]="pickerType"
      [hour12Timer]="onlyTime"
      pickerMode="dialog"
      #dt8
    ></owl-date-time>
  `,
})
export class DatetimepickerComponent implements OnInit {
  @Input() onlyDate = false;
  @Input() onlyTime = false;
  @Output() dateChange = new EventEmitter();

  @Input()
  set date(value) {
    this._date = value ? this.helper.validateDate(value) : new Date();
  }

  get date() {
    return this._date;
  }

  @Input()
  set minDate(value) {
    this.date =
      this.date < this.helper.validateDate(value)
        ? this.helper.validateDate(value)
        : this.date;
    this.min = this.helper.validateDate(value);
  }

  @Input()
  set maxDate(value) {
    this.date =
      this.date > this.helper.validateDate(value)
        ? this.helper.validateDate(value)
        : this.date;
    this.max = this.helper.validateDate(value);
  }

  @Input() disabled = false;

  public pickerType: string;
  public min = null;
  public max = null;

  private _date = null;

  constructor(private helper: HelperService) {}

  ngOnInit() {
    // this.settings = {
    //   // bigBanner: true,
    //   timePicker: !this.onlyDate,
    //   format: this.onlyDate ? 'yyyy-MM-dd' : 'yyyy-MM-dd hh:mm a',
    //   closeOnSelect: true
    // }
    this.pickerType = this.onlyDate
      ? 'calendar'
      : this.onlyTime
      ? 'timer'
      : 'both';
  }

  onDateSelect(event) {
    this.dateChange.emit(event.value);
  }
}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/datetimepicker/datetimepicker.component.ts